import React from "react";
import { withTranslation } from "react-i18next";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import CustomButton from "../../common/CustomButton";

const IssueSalesNoteModal = ({ isModalOpen, loader, onIssueBtnHandler, onChooseBtnHandler, onCloseBtnHandler, t }) => {
  const handleModalClose = () => {
    if (!loader) onCloseBtnHandler();
  };

  return (
    <>
      <Modal centered isOpen={isModalOpen} toggle={handleModalClose} fade={false}>
        <ModalHeader>{t("common.issueSalesNotes")}</ModalHeader>
        <ModalBody>{t("confirmation.issueSalesNotes")}</ModalBody>
        <ModalFooter>
          <CustomButton
            isLoading={loader}
            color={"success"}
            btnTitle={t("common.issueAll")}
            onClick={() => {
              onIssueBtnHandler();
            }}
          />
          <CustomButton disabled={loader} btnTitle={t("common.choose")} onClick={onChooseBtnHandler} />
          <CustomButton disabled={loader} color={"dark"} btnTitle={t("common.cancel")} onClick={handleModalClose} />
        </ModalFooter>
      </Modal>
    </>
  );
};

export default withTranslation()(IssueSalesNoteModal);
